<template>
  <v-dialog persistent v-model="dialog" max-width="700">
    <v-card>
      <v-card-title class="headline">
        {{
          isSignatureEditable ? 'Sign migration PAL' : 'Migration PAL signed'
        }}
      </v-card-title>
      <v-card-subtitle v-if="isSignatureEditable">
        When you sign this migration PAL, it will be in a read-only state.
      </v-card-subtitle>
      <v-card-text>
        <v-row>
          <v-col xs="12" md="6">
            <v-form ref="form">
              <v-row dense>
                <v-col xs="12">
                  <v-text-field
                    label="First name"
                    :disabled="!isSignatureEditable"
                    :rules="firstNameRules"
                    v-model="firstName"
                  />
                </v-col>
              </v-row>
              <v-row dense>
                <v-col xs="12">
                  <v-text-field
                    label="Last name"
                    :disabled="!isSignatureEditable"
                    :rules="lastNameRules"
                    v-model="lastName"
                  />
                </v-col>
              </v-row>
            </v-form>
          </v-col>
          <v-col xs="12" md="6">
            <v-card>
              <v-col class="signature-container" xs="12">
                <img
                  class="signature-image"
                  :src="signatureUrl"
                  :alt="`${firstName} ${lastName} signed`"
                  v-if="signatureUrl"
                />
                <VueSignature
                  :class="signatureUrl ? 'd-none' : ''"
                  ref="signCanvas"
                />
              </v-col>
              <v-col xs="12" v-if="isSignatureEditable">
                <v-btn text outlined class="ml-2" @click="handleSignUndo">
                  Undo
                </v-btn>
                <v-btn text outlined class="ml-2" @click="handleSignClear">
                  Clear
                </v-btn>
              </v-col>
            </v-card>
            <span class="error--text caption" v-if="showSignatureEmptyError">
              Signature is required
            </span>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn text color="accent" :disabled="loading" @click="handleClose">
          {{ isSignatureEditable ? 'Cancel' : 'Close' }}
        </v-btn>
        <v-btn
          text
          color="primary"
          :loading="loading"
          v-if="isSignatureEditable"
          @click="handleSign"
        >
          Sign
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import VueSignature from 'vue-signature';
import { migrationApiV1 } from '@/api/v1';
import { migrationApiV2 } from '@/api/v2';
import { StepsStatusesMap } from '@/constants';

export default {
  data() {
    return {
      dialog: false,
      resultId: '',
      firstNameRules: [(value) => !!value || 'First name is required'],
      lastNameRules: [(value) => !!value || 'Last name is required'],
      showSignatureEmptyError: false,
      firstName: '',
      lastName: '',
      loading: false,
      currentStep: null,
      signatureUrl: null
    };
  },
  computed: {
    isSignatureEditable() {
      return (
        this.currentStep && this.currentStep.status !== StepsStatusesMap.SIGNED
      );
    }
  },
  methods: {
    open(resultId, currentStep) {
      this.dialog = true;
      this.resultId = resultId;
      this.currentStep = currentStep;
      this.fillSignatureInfo();
    },
    fillSignatureInfo() {
      if (this.currentStep && this.currentStep.signature) {
        this.signatureUrl = this.currentStep.signature;
        const [firstName, lastName] = this.currentStep.signer.split(' ');
        this.firstName = firstName;
        this.lastName = lastName;
      }
    },
    handleClose() {
      this.dialog = false;
      this.loading = false;
      this.currentStep = null;
      this.handleSignClear();
      this.$refs.form.reset();
    },
    handleSignUndo() {
      this.$refs.signCanvas.undo();
    },
    handleSignClear() {
      this.$refs.signCanvas.clear();
      this.showSignatureEmptyError = false;
    },
    async handleSign() {
      const isFormValid = this.$refs.form.validate();
      const isSignCanvasEmpty = this.$refs.signCanvas.isEmpty();
      this.showSignatureEmptyError = isSignCanvasEmpty;

      if (isFormValid && !isSignCanvasEmpty) {
        this.loading = true;
        await (
          this.$store.getters.isMatcherApiV2Enabled
            ? migrationApiV2
            : migrationApiV1
        ).saveSignature(this.resultId, {
          firstName: this.firstName,
          lastName: this.lastName,
          signature: this.$refs.signCanvas.save('image/jpeg')
        });
        this.$emit('onSigned');
        this.handleClose();
      }
    }
  },
  components: {
    VueSignature
  }
};
</script>

<style lang="scss">
.signature-container {
  box-shadow:
    0 3px 1px -2px rgb(0 0 0 / 20%),
    0px 2px 2px 0px rgb(0 0 0 / 14%),
    0px 1px 5px 0px rgb(0 0 0 / 12%);

  .signature-image {
    min-height: 150px;
  }
}
</style>
